/**
 * Created by mark on 17/12/2017.
 */

import BaseStore from './base-store.js';
import Constants from '../constants.js';

var _registerToActions = function (action) {

    switch (action.actionType) {
        case Constants.GET_LANGUAGES:
            this.languages = action.response.languagesArray
            this.emit(Constants.GET_LANGUAGES);
            break;
        case Constants.GET_SHARED_CURRICULUM:

            this.sharedCurriculm = action.response
            this.emit(Constants.GET_SHARED_CURRICULUM);
            break;
        case Constants.GET_ADDITIONAL_CURRICULUM:
            this.additionalCurriculm = action.response
            this.emit(Constants.GET_ADDITIONAL_CURRICULUM);
            break;
        case Constants.GET_USER_DATA:
            this.userData = action.response
            this.emit(Constants.GET_USER_DATA);
            break;
        case Constants.GET_VIDEO_DATA:
            this.videoData = action.response
            this.emit(Constants.GET_VIDEO_DATA);
            break;
    }

};

class ProductStore extends BaseStore {

    constructor() {
        super();
        this.subscribe(() => _registerToActions.bind(this));
        this.languages = [];
        this.product = sessionStorage.getItem("product") ? sessionStorage.getItem("product") : "languagenut";
        this.additionalCurriculm = [];
        this.userData = {};
        this.videoData = {};
    }

    getAdditionalCurriculums() {
        return this.additionalCurriculm;
    }

    getSharedAdditionalCurriculums() {
        return this.sharedCurriculm;
    }

    getUserData() {
        return this.userData;
    }

    getVideoData() {
        return this.videoData;
    }

    getLogo() {
        return "img/logos/" + this.product + "/200px.png";
    }

    getLanguages() {
        return this.languages || [];
    }

    getInterfaceLanguages() {
        let l = this.getLanguages();
        let p = [];

        for (var i = 0; i < l.length; i++) {
            if (l[i].isInterface == '1') p.push(l[i]);
        }
        function compare(a, b) {
            if (a.isPriority > b.isPriority) {
                return -1;
            }
            if (a.isPriority < b.isPriority) {
                return 1;
            }
            return 0;
        }

        p = p.sort(compare);

        return p || [];
    }

    getLearningLanguages() {
        let l = this.getLanguages();
        let p = [];

        for (var i = 0; i < l.length; i++) {
            if (l[i].isInterface == '0') p.push(l[i]);
        }
        function compare(a, b) {
            if (a.isPriority > b.isPriority) {
                return -1;
            }
            if (a.isPriority < b.isPriority) {
                return 1;
            }
            return 0;
        }

        p = p.sort(compare);

        return p || [];
    }

    getCurriculumLanguage($ietf, curriculumUid) {
        const allLanguage = {
            alignRight: "0",
            baseName: "All",
            bronzeMedals: 0,
            curriculumUid: "",
            curriculum_name: "",
            goldMedals: 0,
            hasAudio: "1",
            hasSentence: "1",
            hasSpeaking: "1",
            ietf: "all",
            isEAL: "0",
            isInterface: "0",
            isPriority: "1",
            name: "12230",
            packageUid: "8",
            silverMedals: 0
        };

        const english = {
            alignRight: "0",
            baseName: "English",
            bronzeMedals: 0,
            curriculumUid: "",
            curriculum_name: "",
            goldMedals: 0,
            hasAudio: "1",
            hasSentence: "1",
            hasSpeaking: "1",
            ietf: "en",
            isEAL: "0",
            isInterface: "0",
            isPriority: "1",
            name: "45",
            silverMedals: 0
        };

        let l = this.getLanguages();

        console.log(l)
        for (var i = 0; i < l.length; i++) {
            if (l[i].isInterface == '0' && l[i].ietf == $ietf && curriculumUid == l[i].curriculumUid) {
                return l[i];
            } else if (l[i].isInterface == '0' && l[i].ietf == $ietf && curriculumUid == undefined) {
                return l[i];
            }
        }
        if ($ietf == "all") {
            return allLanguage;
        }
        if ($ietf == "en") {
            return english;
        }
        return [];
    }

}

export default new ProductStore();